import { render, staticRenderFns } from "./CourseDetailModal.vue?vue&type=template&id=f77812e2&scoped=true"
import script from "./CourseDetailModal.vue?vue&type=script&lang=js"
export * from "./CourseDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailModal.vue?vue&type=style&index=0&id=f77812e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77812e2",
  null
  
)

export default component.exports